var _circle, _path, _circle2, _path2, _circle3, _path3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAround(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 25.25,
    stroke: "#141B34",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7373 33.1811H29.1593C25.4529 33.1811 22.954 37.0346 24.414 40.4986C24.6174 40.9812 25.084 41.2941 25.6003 41.2941H26.5082C26.8142 41.2941 27.081 41.5058 27.1552 41.8077L28.3239 46.5615C28.5676 47.5527 29.4435 48.248 30.4483 48.248C31.4531 48.248 32.329 47.5527 32.5727 46.5615L33.7414 41.8077C33.8157 41.5058 34.0824 41.2941 34.3884 41.2941H35.2963C35.8126 41.2941 36.2792 40.9812 36.4826 40.4986C37.9426 37.0346 35.4437 33.1811 31.7373 33.1811Z",
    fill: "#8F79D7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.4483,
    cy: 29.9524,
    r: 3.22863,
    fill: "#8F79D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6083 19.4228H19.0303C15.3239 19.4228 12.825 23.2763 14.2851 26.7403C14.4884 27.2229 14.9551 27.5358 15.4714 27.5358H16.3792C16.6852 27.5358 16.952 27.7475 17.0262 28.0494L18.195 32.8032C18.4387 33.7944 19.3145 34.4897 20.3193 34.4897C21.3241 34.4897 22.2 33.7944 22.4437 32.8032L23.6125 28.0494C23.6867 27.7475 23.9534 27.5358 24.2594 27.5358H25.1673C25.6836 27.5358 26.1502 27.2229 26.3536 26.7403C27.8136 23.2763 25.3147 19.4228 21.6083 19.4228Z",
    fill: "#8F79D7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.3193,
    cy: 16.1941,
    r: 3.22863,
    fill: "#8F79D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8662 19.4228H39.2882C35.5818 19.4228 33.0829 23.2763 34.5429 26.7403C34.7463 27.2229 35.2129 27.5358 35.7292 27.5358H36.6371C36.9431 27.5358 37.2098 27.7475 37.2841 28.0494L38.4528 32.8032C38.6965 33.7944 39.5724 34.4897 40.5772 34.4897C41.582 34.4897 42.4579 33.7944 42.7016 32.8032L43.8703 28.0494C43.9445 27.7475 44.2113 27.5358 44.5173 27.5358H45.4251C45.9414 27.5358 46.4081 27.2229 46.6115 26.7403C48.0715 23.2763 45.5726 19.4228 41.8662 19.4228Z",
    fill: "#8F79D7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5772,
    cy: 16.1941,
    r: 3.22863,
    fill: "#8F79D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAround);
export default __webpack_public_path__ + "static/media/icon-around.89cf7c7986cabbf5446ca99c9c2ab82e.svg";
export { ForwardRef as ReactComponent };